import React from 'react';
import { COMMON_MODAL_IDS } from 'common/constants/modal.constants';
import { SessionEndedSvg } from 'common/ui/themes/disona/icons2';
import { stores } from 'stores';
import { CTAModal } from '../../CTA';

const { AppStore } = stores;

export const SessionExpiredModalDisona = () => {
  return (
    <CTAModal
      modalID={COMMON_MODAL_IDS.SESSION_EXPIRED}
      heading="Session expired"
      onClose={AppStore.logout}
      icon={<SessionEndedSvg />}
      buttonText="Log in"
      greenButton
    >
      <span style={{ maxWidth: '220px' }}>
        We ended your session because you were inactive for a long time.
      </span>
    </CTAModal>
  );
};
